<template>
  <v-menu
    :close-on-content-click="false"
    v-bind="{
      top,
      bottom,
      right,
      left,
      offsetX,
      offsetY,
    }"
  >
    <template #activator="{ on, attrs }">
      <slot
        name="activator"
        v-bind="{ on, attrs }"
      />
    </template>

    <v-card width="300px">
      <user-menu />
      <v-divider />
      <app-menu />
    </v-card>

    <v-btn
      block
      tile
      color="primary"
      @click="logout"
      v-text="'Sign out'"
    />
  </v-menu>
</template>

<script>
import { toRhitics } from '@rhitics/utils/links'
import AppMenu from './AppMenu.vue'
import UserMenu from './UserMenu.vue'

export default {
  name: 'AccessMenu',

  components: {
    AppMenu,
    UserMenu
  },

  props: [
    'right',
    'top',
    'bottom',
    'left',
    'offset-x',
    'offset-y'
  ],

  data() {
    return {
      tabs: ['basic', 'preference']
    }
  },

  computed: {
    user() {
      return this.$auth.user
    }
  },

  methods: {
    toAccountPage(subPage) {
      toRhitics('account', subPage)
    },

    logout() {
      toRhitics('logout')
    }
  }
}
</script>
